import { CreateButton, List, useTable } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import { Button, Space, Table, Tag, Typography } from "antd";

import { AppImagePreview } from "../../../components";
import { TV_SHOW_KIND_LABELS, TvShow, tvErrorNotification } from "../Lib";
import { TvDelete } from "../Components";

export const TvShowsPage = () => {
  const { push } = useNavigation();
  const { tableProps, tableQueryResult } = useTable<TvShow>({
    resource: "tv-shows",
    dataProviderName: "tvDataProvider",
    syncWithLocation: false,
    pagination: { mode: "off" },
    ...tvErrorNotification("Не удалось загрузить"),
  });

  return (
    <List
      title="ФНЛ ТВ — шоу и спецпроекты"
      resource="tv-shows"
      breadcrumb={false}
      canCreate={false}
      headerButtons={
        <CreateButton resource="tv-shows">Добавить шоу</CreateButton>
      }
    >
      <Typography.Paragraph type="secondary">
        Шоу «Originals» — карусели на странице «ФНЛ ТВ Originals». Спецпроект —
        отдельная страница, кнопку с логотипом можно вывести в хедер. Порядок —
        по полю «Порядок», меньше — выше.
      </Typography.Paragraph>
      <Table
        {...tableProps}
        rowKey="id"
        pagination={false}
        scroll={{ x: 1000 }}
      >
        <Table.Column<TvShow>
          title="Обложка"
          width={140}
          render={(_, s) =>
            s.coverUrl ? (
              <AppImagePreview
                imageURL={s.coverUrl}
                useS3={!s.coverUrl.startsWith("http")}
              />
            ) : (
              "—"
            )
          }
        />
        <Table.Column<TvShow>
          title="Шоу"
          render={(_, s) => (
            <Space direction="vertical" size={2}>
              <Typography.Text strong>{s.title}</Typography.Text>
              <Typography.Text type="secondary">/{s.slug}</Typography.Text>
            </Space>
          )}
        />
        <Table.Column<TvShow>
          title="Вид"
          width={220}
          render={(_, s) => (
            <Space size={4} wrap>
              <Tag>{TV_SHOW_KIND_LABELS[s.kind]}</Tag>
              {!s.isActive && <Tag color="orange">Выключено</Tag>}
            </Space>
          )}
        />
        <Table.Column<TvShow>
          title="Выпусков"
          dataIndex="episodesCount"
          width={100}
        />
        <Table.Column<TvShow>
          title="Порядок"
          dataIndex="sortOrder"
          width={100}
        />
        <Table.Column<TvShow>
          title="Действия"
          width={200}
          fixed="right"
          render={(_, s) => (
            <Space direction="vertical" style={{ width: "100%" }}>
              <Button
                size="small"
                block
                onClick={() => push(`/tv/shows/${s.id}`)}
              >
                Открыть
              </Button>
              <TvDelete
                resource="tv-shows"
                id={s.id}
                name={s.title}
                entityAccusative="шоу"
                onDeleted={() => tableQueryResult.refetch()}
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
